import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import '@humi-design-library/components/Tip';
@Component({
    selector: 'ui-tip',
    standalone: true,
    templateUrl: './tip.template.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WebTipComponent {}
